var React = require('react');

function RightCarrot (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.36804 5.45553C6.36641 5.24383 6.28238 5.04125 6.13403 4.89062L2.22567 0.982324C1.90812 0.663303 1.39205 0.662165 1.07303 0.979714C0.754007 1.29726 0.752867 1.81332 1.07043 2.13233L4.40377 5.46563L1.07043 8.79893C0.752867 9.11795 0.754007 9.634 1.07303 9.95155C1.39205 10.2691 1.90812 10.268 2.22567 9.94894L6.13403 6.04063C6.28743 5.88495 6.37179 5.67406 6.36804 5.45552V5.45553Z","fill":"#626262"}));
}

RightCarrot.defaultProps = {"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none"};

module.exports = RightCarrot;

RightCarrot.default = RightCarrot;
